@if (designs.length) {
  <customizer-component-header
    class="clip-on-component"
    [menu]="menu"
    (updateCollapsedOnComponent)="updateCollapsed($event)"
    >
    @if (state !== isEditOrder) {
      <div
        class="has-padding-horizontal-30px clip-on-switch"
        >
        <cstmsr-toggle
          [on]="onlyClipOnChecked"
          [color]="'#33cc33'"
          (valueChanged)="setClipOnOnly($event)"
          >
          {{ 'CUSTOMIZER.COMPONENTS.CLIP-ON.CLIP-ONONLY' | translate }}
        </cstmsr-toggle>
      </div>
    }
    @if (!noDesign) {
      <select-box
        [optionsCaption]="onlyClipOnChecked? '' : 'CUSTOMIZER.COMPONENTS.CLIPON.NOCLIPON'"
        [optionsImage]="getImage"
        [options]="designs"
        [editMode]="state === customizerStateEnum.EDITORDER"
        [colorMatchMode]="false"
        [colorsAvailableForMatching]="allPossibleColorsOnOtherSelectedVariants"
        [currentColor]="currentVariantColor"
        (matchColors)="matchColors(null)"
        optionsText="Description"
        optionsId="Id"
        [selected]="currentVariantNotSelected ? null : getSelectedVariant"
        (selectedChange)="onSelected($event)"
        [optionsDiscontinued]="'Discontinued'"
        [optionsDescription2]="'Description2'"
        [variantOrModelIsNew]="variantOrModelIsNew"
        [matchColor]="menu.matchColor"
      ></select-box>
    }
    @if (noDesign) {
      <h4>{{'CUSTOMIZER.COMPONENTS.CLIPON.NOTAVAILABLE'|translate}}</h4>
    }
  </customizer-component-header>
}